import * as React from 'react';
import {Svg, G, Path, Defs, ClipPath} from 'react-native-svg';

const VisaCard = props => {
  return (
    <Svg
      width={46}
      height={30}
      viewBox="0 0 46 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <G
        clipPath="url(#clip0_24105_13305)"
        fillRule="evenodd"
        clipRule="evenodd">
        <Path
          d="M0 2.114C0 .947.947 0 2.114 0H42.99c1.168 0 2.114.947 2.114 2.114v25.37A2.114 2.114 0 0142.99 29.6H2.114A2.114 2.114 0 010 27.485V2.115z"
          fill="#F4F6F7"
        />
        <Path
          d="M0 2.114C0 .947.947 0 2.114 0H42.99c1.168 0 2.114.947 2.114 2.114v4.933H0V2.114z"
          fill="#4095DB"
        />
        <Path
          d="M0 22.553h45.103v4.933A2.114 2.114 0 0142.99 29.6H2.114A2.114 2.114 0 010 27.486v-4.933z"
          fill="#F4B662"
        />
        <Path
          d="M28.388 10.267a5.015 5.015 0 00-1.989-.401c-2.194 0-3.739 1.297-3.752 3.155-.014 1.373 1.102 2.14 1.944 2.596.865.468 1.155.768 1.152 1.186-.006.64-.69.934-1.328.934-.89 0-1.361-.144-2.091-.501l-.286-.152-.31 2.139c.517.266 1.477.497 2.473.51 2.332 0 3.847-1.282 3.865-3.265.008-1.09-.583-1.916-1.864-2.598-.776-.443-1.252-.736-1.247-1.185 0-.397.403-.822 1.272-.822a3.569 3.569 0 011.661.367l.2.11.3-2.073zm-10.27 9.323l1.388-9.558h2.22l-1.39 9.558h-2.219zm14.11-6.06s-.7 2.122-.885 2.671h1.843c-.088-.478-.514-2.759-.514-2.759l-.15-.824c-.059.19-.141.44-.204.631a6.21 6.21 0 00-.09.28zm1.854-3.486h-1.716c-.532 0-.93.17-1.163.792l-3.296 8.76h2.331s.38-1.179.467-1.437c.12 0 .683 0 1.28.002l1.563.003c.066.333.27 1.432.27 1.432h2.06l-1.796-9.552zm-17.827-.004l-2.172 6.517-.233-1.325v-.002l-.778-4.39c-.134-.605-.524-.785-1.006-.806h-3.58l-.029.198c.87.248 1.65.605 2.332 1.049l1.974 8.301 2.349-.002 3.495-9.54h-2.352z"
          fill="#0071CE"
        />
        <Path
          d="M0 1.5A1.5 1.5 0 011.5 0h29A1.5 1.5 0 0132 1.5v18a1.5 1.5 0 01-1.5 1.5h-29A1.5 1.5 0 010 19.5v-18z"
          fill="#E5E5E5"
          fillOpacity={0.01}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_24105_13305">
          <Path fill="#fff" d="M0 0H45.1034V29.5991H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export default VisaCard;
